
declare var AuthBar: any;
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import api from "../../api/newget"
@Component({
  components: {
  },
})
export default class NoCompany extends Vue {

  private async logout(){
     try{
      const res = await api.get("/logout");
      if (res && res.status === 200) {
        console.log("Logout successful");
        this.$store.dispatch('onLogout');
      } else {
        console.error("Logout failed", res.data.message);
      }
    }catch(e){
      console.error("Error while calling logout API on logout", e);
    }
  }

  public closeModal() {
    this.logout();
    this.$store.commit('setModal', '');
  }

}

